import { Component, OnInit, Input } from '@angular/core';
import { formatNumber } from '../../../utils/common';

@Component({
  selector: 'icc-total-mo-email',
  templateUrl: './icc-total-mo-email.component.html',
  styleUrls: ['./icc-total-mo-email.component.less'],
})
export class IccTotalMoEmailComponent implements OnInit {
  constructor() {}

  @Input() data: {
    count: 'number';
    users: 'number';
    keywords: 'number';
    others: 'number';
    replies: 'number';
  };

  viewData: {
    count: 'string';
    users: 'string';
    keywords: 'string';
    others: 'string';
    replies: 'string';
  };

  ngOnInit() {
    const viewData: any = {};
    if (this.data) {
      for (const key in this.data) {
        if (this.data.hasOwnProperty(key)) {
          const number = this.data[key];
          viewData[key] = formatNumber(number);
        }
      }
    }
    this.viewData = viewData;
  }
}
